module.exports = __webpack_public_path__ + "static/dmytro-a963d3c092c63ec42bffc184e8633cf0.png";